// extracted by mini-css-extract-plugin
export default {"anchor":"NoDecoAnchor_anchor__OvLoy"};